import { cva, type VariantProps } from 'class-variance-authority';

export const buttonVariantClasses = {
  default: 'bg-primary text-primary-foreground shadow hover:bg-primary/90',
  destructive: 'bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90',
  outline:
    'border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground',
  destructiveOutline:
    'border border-destructive/50 bg-background text-destructive shadow-sm hover:bg-destructive/10 hover:text-destructive',
  secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
  ghost: 'hover:bg-accent hover:text-accent-foreground',
  link: 'text-primary underline-offset-4 hover:underline',
  icon: 'text-primary hover:scale-110 transition-all duration-150'
};

export const buttonSizeClasses = {
  default: 'h-9 px-4 py-2',
  xs: 'h-7 p-2 text-xs',
  sm: 'h-8 px-3 text-xs',
  lg: 'h-10 px-8',
  icon: 'h-9 w-9 shrink-0 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
  smIcon: 'h-7 w-7 shrink-0 [&_svg]:pointer-events-none [&_svg]:size-3 [&_svg]:shrink-0'
};

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-[number:var(--button-font-weight,500)] transition-colors ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ',
  {
    variants: {
      variant: buttonVariantClasses,
      size: buttonSizeClasses
    },
    defaultVariants: {
      variant: 'default',
      size: 'default'
    }
  }
);

export type ButtonVariantsProps = VariantProps<typeof buttonVariants>;
